"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _elevation = _interopRequireDefault(require("../../utils/elevation"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable no-shadow */
var determineRadius = function determineRadius(radius) {
  return typeof radius === "number" ? radius + "px" : radius;
};

var determineBorder = function determineBorder(_ref) {
  var theme = _ref.theme,
      border = _ref.border,
      borderColor = _ref.borderColor;
  var splitColor = (borderColor || "dark.4").split(".");
  if (!theme || !theme.colors) return "none";
  return border + " " + theme.colors[splitColor[0]][splitColor[1]];
};

var Col = _styledComponents["default"].col.withConfig({
  displayName: "Table__Col",
  componentId: "sc-16rj3eg-0"
})(["", ""], _styledSystem.width);

var SpinnerContainer = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Table__SpinnerContainer",
  componentId: "sc-16rj3eg-1"
})(["border-bottom-left-radius:", ";border-bottom-right-radius:", ";"], function (_ref2) {
  var borderBottomLeftRadius = _ref2.borderBottomLeftRadius;
  return determineRadius(borderBottomLeftRadius);
}, function (_ref3) {
  var borderBottomRightRadius = _ref3.borderBottomRightRadius;
  return determineRadius(borderBottomRightRadius);
});
var NoHeadingsBorders = (0, _styledComponents.css)(["tr:first-child td{border-top:", ";}tr:first-child td:first-child{border-top-left-radius:", ";}tr:first-child td:last-child{border-top-right-radius:", ";}"], determineBorder, function (_ref4) {
  var borderRadius = _ref4.borderRadius;
  return determineRadius(borderRadius);
}, function (_ref5) {
  var borderRadius = _ref5.borderRadius;
  return determineRadius(borderRadius);
});
var NoRowsBorders = (0, _styledComponents.css)(["tr:first-child th{border-bottom:", ";}tr:first-child th:first-child{border-bottom-left-radius:", ";}tr:first-child th:last-child{border-bottom-right-radius:", ";}"], determineBorder, function (_ref6) {
  var borderRadius = _ref6.borderRadius;
  return determineRadius(borderRadius);
}, function (_ref7) {
  var borderRadius = _ref7.borderRadius;
  return determineRadius(borderRadius);
});

var StyledTable = _styledComponents["default"].table.withConfig({
  displayName: "Table__StyledTable",
  componentId: "sc-16rj3eg-2"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " display:table;border-collapse:separate;border-spacing:0;min-width:350px;table-layout:", ";overflow:hidden;& tr:last-child td{border-bottom:", ";}& tr th:last-child,& tr td:last-child{border-right:", ";}& tr th{border-top:", ";}& tr th:first-child,& tr td:first-child{border-left:", ";}tr:first-child th:first-child{border-top-left-radius:", ";}tr:first-child th:last-child{border-top-right-radius:", ";}tr:last-child td:first-child{border-bottom-left-radius:", ";}tr:last-child td:last-child{border-bottom-right-radius:", ";}", ";", ";"], _styledSystem.textAlign, _styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.lineHeight, _styledSystem.letterSpacing, _styledSystem.fontStyle, _styledSystem.color, _styledSystem.width, _styledSystem.space, _styledSystem.height, _elevation["default"], _styledSystem.maxWidth, _styledSystem.minWidth, _styledSystem.maxHeight, _styledSystem.minHeight, _styledSystem.size, _styledSystem.position, _styledSystem.textAlign, function (_ref8) {
  var tableLayout = _ref8.tableLayout;
  return tableLayout;
}, determineBorder, determineBorder, determineBorder, determineBorder, function (_ref9) {
  var borderRadius = _ref9.borderRadius;
  return determineRadius(borderRadius);
}, function (_ref10) {
  var borderRadius = _ref10.borderRadius;
  return determineRadius(borderRadius);
}, function (_ref11) {
  var borderRadius = _ref11.borderRadius;
  return determineRadius(borderRadius);
}, function (_ref12) {
  var borderRadius = _ref12.borderRadius;
  return determineRadius(borderRadius);
}, function (_ref13) {
  var headings = _ref13.headings;
  return !headings && NoHeadingsBorders;
}, function (_ref14) {
  var rows = _ref14.rows;
  return !rows && NoRowsBorders;
});

var StyledTH = _styledComponents["default"].th.withConfig({
  displayName: "Table__StyledTH",
  componentId: "sc-16rj3eg-3"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " word-wrap:break-word;hyphens:auto;"], _styledSystem.border, _styledSystem.textAlign, _styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.lineHeight, _styledSystem.letterSpacing, _styledSystem.fontStyle, _styledSystem.space, _styledSystem.color);

var StyledTD = _styledComponents["default"].td.withConfig({
  displayName: "Table__StyledTD",
  componentId: "sc-16rj3eg-4"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " word-wrap:break-word;hyphens:auto;"], _styledSystem.borders, _styledSystem.borderColor, _styledSystem.space, _styledSystem.textAlign, _styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.lineHeight, _styledSystem.letterSpacing, _styledSystem.fontStyle, _styledSystem.color, _styledSystem.position);

var StyledTR = _styledComponents["default"].tr.withConfig({
  displayName: "Table__StyledTR",
  componentId: "sc-16rj3eg-5"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], _styledSystem.border, _styledSystem.textAlign, _styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.lineHeight, _styledSystem.letterSpacing, _styledSystem.fontStyle, _styledSystem.space, _styledSystem.color);

var StyledTHead = _styledComponents["default"].thead.withConfig({
  displayName: "Table__StyledTHead",
  componentId: "sc-16rj3eg-6"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], _styledSystem.border, _styledSystem.space, _styledSystem.textAlign, _styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.lineHeight, _styledSystem.letterSpacing, _styledSystem.fontStyle, _styledSystem.color, _styledSystem.textAlign);

var StyledTBody = _styledComponents["default"].tbody.withConfig({
  displayName: "Table__StyledTBody",
  componentId: "sc-16rj3eg-7"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], _styledSystem.border, _styledSystem.space, _styledSystem.textAlign, _styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.lineHeight, _styledSystem.letterSpacing, _styledSystem.fontStyle, _styledSystem.color, _styledSystem.textAlign);

var TH = function TH(_ref15) {
  var children = _ref15.children,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref15, ["children"]);
  return _react["default"].createElement(StyledTH, props, children);
};

var TD = function TD(_ref16) {
  var children = _ref16.children,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref16, ["children"]);
  return _react["default"].createElement(StyledTD, props, children);
};

var Table = function Table(_ref17) {
  var children = _ref17.children,
      headings = _ref17.headings,
      subHeadings = _ref17.subHeadings,
      config = _ref17.config,
      border = _ref17.border,
      borderColor = _ref17.borderColor,
      rows = _ref17.rows,
      width = _ref17.width,
      isLoading = _ref17.isLoading,
      caption = _ref17.caption,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref17, ["children", "headings", "subHeadings", "config", "border", "borderColor", "rows", "width", "isLoading", "caption"]);
  var determinedConfig = {
    stylesPerColumn: config.stylesPerColumn || headings && headings.map(function () {
      return {};
    }) || [],
    main: (0, _extends2["default"])({
      textAlign: "center",
      tableLayout: "fixed",
      borderRadius: "1em",
      border: "2px solid",
      borderColor: "dark.7"
    }, config.main),
    head: (0, _extends2["default"])({
      bg: "dark.6"
    }, config.head),
    heading: (0, _extends2["default"])({
      py: 2,
      color: "dark.2",
      fontWeight: 500,
      fontSize: 4
    }, config.heading),
    headingPerColumn: config.headingPerColumn,
    subHeadingsPerColumn: config.subHeadingsPerColumn,
    body: (0, _extends2["default"])({}, config.body),
    row: (0, _extends2["default"])({}, config.row),
    data: (0, _extends2["default"])({
      color: "dark.2",
      fontWeight: 400,
      fontSize: 3,
      py: 2
    }, config.data),
    // specialCells: {    // eg of data structure
    //   "3&5": {
    //     color: "..."
    //   }
    // }
    specialCells: config.specialCells
  };
  return _react["default"].createElement(_Flex["default"], {
    flexDirection: "column",
    width: width
  }, _react["default"].createElement(StyledTable, (0, _extends2["default"])({
    width: 1 / 1
  }, props, determinedConfig.main, {
    headings: headings,
    rows: rows
  }), caption && _react["default"].createElement("caption", null, caption), config.columnWidths && _react["default"].createElement("colgroup", null, config.columnWidths.map(function (width, index) {
    return _react["default"].createElement(Col, {
      width: width,
      key: index.toString()
    });
  })), headings && _react["default"].createElement(StyledTHead, determinedConfig.head, _react["default"].createElement(StyledTR, null, headings.map(function (heading, colIndex) {
    return _react["default"].createElement(TH, (0, _extends2["default"])({
      key: heading.id
    }, determinedConfig.headingPerColumn ? (0, _extends2["default"])({}, determinedConfig.headingPerColumn[colIndex]) : (0, _extends2["default"])({}, determinedConfig.heading)), heading.title);
  }))), subHeadings && subHeadings.map(function (subHeading, subHeadingIndex, array) {
    var sortedData = headings ? headings.map(function (heading) {
      return subHeading[heading.id];
    }) : Object.keys(array[0]).map(function (key) {
      return subHeading[key];
    });
    return _react["default"].createElement(StyledTR, (0, _extends2["default"])({}, determinedConfig.subHeading, {
      key: "subHeading-" + subHeadingIndex.toString()
    }), sortedData.map(function (datum, colIndex) {
      return _react["default"].createElement(TD // {...determinedConfig.data}
      , (0, _extends2["default"])({}, determinedConfig.subHeadingsPerColumn[colIndex], {
        key: subHeadingIndex.toString() + "-" + colIndex.toString()
      }), datum);
    }));
  }), !isLoading && rows && _react["default"].createElement(StyledTBody, determinedConfig.body, rows.map(function (row, rowIndex, array) {
    var sortedData = headings ? headings.map(function (heading) {
      return row[heading.id];
    }) : Object.keys(array[0]).map(function (key) {
      return row[key];
    });
    return _react["default"].createElement(StyledTR, (0, _extends2["default"])({}, determinedConfig.row, {
      key: "row-" + rowIndex.toString()
    }), sortedData.map(function (datum, colIndex) {
      return _react["default"].createElement(TD, (0, _extends2["default"])({}, determinedConfig.data, determinedConfig.stylesPerColumn[colIndex], {
        key: rowIndex.toString() + "-" + colIndex.toString()
      }), datum);
    }));
  }))), isLoading && _react["default"].createElement(SpinnerContainer, {
    justifyContent: "center",
    py: 3,
    width: 1 / 1,
    borderBottomLeftRadius: determinedConfig.main.borderRadius,
    borderBottomRightRadius: determinedConfig.main.borderRadius,
    border: determinedConfig.main.border,
    borderColor: determinedConfig.main.borderColor
  }, _react["default"].createElement(_Spinner["default"], {
    color: "primary.0"
  })));
};

var _default = Table;
exports["default"] = _default;